import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import './styles.scss';
import OrdersService, { ordersService } from '../../../services/Orders';
import { Subscribe } from 'unstated';
import autobind from 'autobind-decorator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons';
import { noun } from 'plural-ru';

export default withRouter(class NewOrderButton extends Component {
    previousSelectedItemsCount = ordersService.selectedItemsCount || 0;

    get currentLocation() {
      return this.props.location.pathname;
    }

    get isOrderPage() {
      return this.currentLocation === '/new-order';
    }

    get doAnimate() {
      return this.previousSelectedItemsCount < ordersService.selectedItemsCount ? 'new-order-button-pulse' : '';
    }

    get isReady() {
      return ordersService.selectedItemsCount && !this.isOrderPage ? '__ready' : '';
    }

    get isSelecting() {
      return (ordersService.state.isSelectingProducts || ordersService.selectedItemsCount && this.isOrderPage) ? '__selecting' : '';
    }

    get pluralizedString() {
      return noun(ordersService.selectedItemsCount, 'добавлен %d товар', 'добавлено %d товара', 'добавлено %d товаров');
    }

    displayDefaultButton() {
      return <>
        <FontAwesomeIcon icon={faTruck}/> Новый заказ
        <span hidden={!ordersService.selectedItemsCount}>{this.pluralizedString}</span>
      </>;
    }

    displaySelectingButton() {
      return (
        <>
          {ordersService.selectedItemsCount ? 'Готово' : 'Вернутся к заказу'}
          <span>{ordersService.selectedItemsCount ? this.pluralizedString : 'ничего не добавлено'}</span>
        </>
      );
    }

    @autobind
    endAnimation() {
      this.previousSelectedItemsCount = ordersService.selectedItemsCount || 0;
      this.forceUpdate();
    }

    render() {
      return (
        <Subscribe to={[OrdersService]}>
          {() => (
            <>
              <NavLink to={{
                         pathname: '/new-order',
                         state: { from: this.currentLocation }
                       }}
                       disabled={this.isOrderPage}
                       onAnimationEnd={this.endAnimation}
                       className={`btn sidebar-item __new-order ${this.isReady} ${this.isSelecting} ${this.doAnimate}`}>
                {(ordersService.state.isSelectingProducts) && !this.isOrderPage && this.displaySelectingButton()}
                {(!ordersService.state.isSelectingProducts || this.isOrderPage) && this.displayDefaultButton()}
              </NavLink>

              <span hidden>{this.previousSelectedItemsCount = ordersService.selectedItemsCount ? this.previousSelectedItemsCount : 0}</span>
            </>
          )}
        </Subscribe>
      );
    }
  }
);
